export const ORDER_LIMIT_KEY = 'OLC_ORDERS_LIMIT_ORDERSNUMBER';
export const LOADS_LIMIT_KEY = 'OLC_ORDERS_LIMIT_LOADSNUMBER';
